/* eslint-disable @typescript-eslint/no-explicit-any */
export interface TreeNodeRoute<TStatus = any> {
    id: string;
    type: TreeNodeType;
    title: string;
    name?: string | null;
    code?: string | null;
    parentId: string | null;
    children: TreeNodeRoute<TStatus>[];
    included: boolean;
    orderIndex: number;
    status?: TStatus | null;
}

export enum TreeNodeType {
    GROUP = "group",
    SUBGROUP = "subgroup",
    ELEMENT = "element",
    ITEM = "item"
}
export interface TreeOptions {
    drag?: boolean;
    checkbox?: boolean;
    selectAll?: boolean;
}

export interface TreeProps<TStatus = any> {
    initialData: TreeNodeRoute<TStatus>[];
    onChange?: (tree: TreeNodeRoute<TStatus>[]) => void;
    options?: TreeOptions;

    renderNodeExtras?: (
        node: TreeNodeRoute<TStatus>,
        updateNode: (id: string, updater: (n: TreeNodeRoute<TStatus>) => TreeNodeRoute<TStatus>) => void
    ) => React.ReactNode;

    rowStyle?: (node: TreeNodeRoute<TStatus>) => React.CSSProperties | undefined;
}